var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 10C12.0141 7.82497 12.1105 6.64706 12.8789 5.87868C13.7576 5 15.1718 5 18.0002 5L19.0002 5C21.8286 5 23.2429 5 24.1215 5.87868C25.0002 6.75736 25.0002 8.17157 25.0002 11L25.0002 19C25.0002 21.8284 25.0002 23.2426 24.1215 24.1213C23.2429 25 21.8286 25 19.0002 25H18.0002C15.1718 25 13.7576 25 12.8789 24.1213C12.1105 23.3529 12.0141 22.175 12.002 20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15L5 15M5 15L8.5 12M5 15L8.5 18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.f907bf35542e78af494f383f9c197f2c.svg";
export { ForwardRef as ReactComponent };